import { createFileRoute, useNavigate } from '@tanstack/react-router'
import * as v from 'valibot'
import { Test } from '@/routes/_app/-components/applicants/test'
import { useSuspenseQuery } from '@tanstack/react-query'
import { trpc } from '@/main'
import { TestStepPending } from '@/routes/_app/-components/shared/flow-pending'

export const Route = createFileRoute('/_app/test/personality')({
  validateSearch: v.object({
    retake: v.optional(v.boolean(), false),
    resume: v.optional(v.boolean()),
    // Carried through onboarding so the final landing can return to the visitor's intended destination.
    redirect: v.optional(v.string()),
  }),
  loaderDeps: ({ search }) => ({ retake: search.retake }),
  loader: ({ context, deps }) => {
    context.queryClient.prefetchQuery(
      trpc.applicants.getQuestions.queryOptions({ type: 'personality', newTest: deps.retake }),
    )
  },
  component: RouteComponent,
  pendingComponent: TestStepPending,
})

function RouteComponent() {
  const navigate = useNavigate()
  const { data: user } = useSuspenseQuery(trpc.auth.getUser.queryOptions())
  const { retake, redirect } = Route.useSearch()
  // Logged-out → /login is enforced centrally by the `_app` layout guard (see route-access).
  // Self-registered applicants continue to the profile wizard (which honors `redirect` on completion);
  // company-invited employees skip it (their profile comes from the company) and go straight to their
  // report. Only the self-registered path carries `redirect` — employees arrive via invitation, never
  // the compare CTA.
  const isEmployee = user?.type === 'applicant' && user.isEmployee
  return (
    <Test
      type="personality"
      nextStep={() =>
        isEmployee
          ? navigate({ to: '/report', viewTransition: true })
          : navigate({ to: '/register/applicant', search: { redirect }, viewTransition: true })
      }
      previousStep={() => navigate({ to: '/test/values', search: { redirect }, viewTransition: true })}
      newTest={retake}
    />
  )
}
